import { useTranslation } from 'react-i18next'
import { Accordion } from './accordion'
import arrowLeft from './assets/images/arrow-left.svg'
import c from './assets/sass/detail.module.scss'

export const Detail = ({ category, onBack }) => {
    const { t } = useTranslation()
    const questions = t(`faq.questions.${category}`, { returnObjects: true })

    return (
        <div>
            <div className={c.header}>
                <div className={c.back} onClick={onBack}>
                    <img src={arrowLeft} alt="" />
                </div>
                <div className={c.info}>
                    <div className={c.title}>
                        {t(`faq.categories.${category}.title`)}
                    </div>
                    <div className={c.description}>
                        {t(`faq.categories.${category}.description`)}
                    </div>
                </div>
            </div>
            <div className={c.list}>
                {Array.isArray(questions) &&
                    questions.map((q, i) => (
                        <Accordion
                            key={i}
                            question={q.question}
                            answer={q.answer}
                        />
                    ))}
            </div>
        </div>
    )
}
